import { lazy } from 'react';
import Loadable from '@/components/base-component/Loadable';
import PagesLayout from '@/layout/Pages';

//============ Page Components ===============
const DashboardDefault = Loadable(lazy(() => import('@/pages/examples/dashboard/default')));
const PaymentResearchAccount = Loadable(lazy(() => import('@/pages/dashboard/payment-research-account')));

// ::: ลำดับชั้นของ Path จะต้องเรียงลำดับให้ตรงในรายการ allowUsers List -->
// ::: ที่อยู่ของรายการ allowUsers List ==> /src/components/bs-component/menu-items/users
export const paymentRoutes = [
  {
    path: 'dashboard', // ไม่ต้องมี "/"
    element: <DashboardDefault />
  },
  {
    path: 'research', // ไม่ต้องมี "/"
    element: <PagesLayout />,
    children: [
      {
        path: 'account', // ไม่ต้องมี "/"
        element: <PaymentResearchAccount />
      }
    ]
  }
];
